import React from 'react'
import PropTypes from 'prop-types'

import { Button, Modal } from '../../../components/Common'

const DuplicateJobsError = ({ show, toggle }) => {
  return (
    <Modal
      header={<Modal.Header><h3>Duplication error</h3></Modal.Header>}
      show={show}
      onHide={toggle}
      footer={
        <Modal.Footer>
          <Button className="button -xsmall" variant="text" onClick={toggle}>
            <span className="material-icons">close</span>
            <span className="button__text">Close</span>
          </Button>
        </Modal.Footer>
      }
    >
      This Job ID has already been used. Please make it unique.
    </Modal>
  )
}

DuplicateJobsError.propTypes = {
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default DuplicateJobsError
